module.exports = __webpack_public_path__ + "img/participant-select-desktop-ru.4f5ff74d.jpg";